import { Container } from '@/components/Containers/Container';
import { Skeleton } from '@frontend/ui/components/skeleton';

export const CampaingsSkeleton = () => {
	return (
		<Container>
			<Skeleton className="h-96" />
		</Container>
	);
};
